/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlSegmentGroup, Route } from '@angular/router';
import { CustomPreloadingStrategy } from './services/custom-preloading-strategy';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { AdminGuardGuard } from './auth/guards/admin-guard.guard';
import { CopyrightShellComponent } from './copyright/copyright-shell/copyright-shell.component';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { MsalGuard } from '@azure/msal-angular';

// route definitions
// Pending Need to make url case insensitive
const appRoutes: Routes = [
  { path: '', canActivate: [MsalGuard], loadChildren: () => import('./project/project.module').then(m => m.ProjectModule) },
  { path: 'evs', canActivate: [MsalGuard], loadChildren: () => import('./project/project.module').then(m => m.ProjectModule) },
  { path: 'tax', canActivate: [MsalGuard], loadChildren: () => import('./project/project.module').then(m => m.ProjectModule) },
  { path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),canActivate: [AdminGuardGuard] },
  { path: 'help', loadChildren: () => import('./help/help.module').then(m => m.HelpModule) },
  { path: 'copyrights', component: CopyrightShellComponent },
  { path: 'app-error', component: NotFoundComponent },
  { path: 'access-denied', component:AccessDeniedComponent },
  { path: '**', component: NotFoundComponent }
];
export function profileMatch(path: string) {
  return CaseInsensitiveMatcher(path).apply(this, arguments);
}
// copy from angular defaultPathMatcher but making that case insensitive
export function CaseInsensitiveMatcher(url: string) {
  return function (
    segments: UrlSegment[],
    segmentGroup: UrlSegmentGroup, // what is url segment group?
    route: Route
  ) {
    const matchSegments = url.split('/');
    if (
      matchSegments.length > segments.length ||
      (matchSegments.length !== segments.length && route.pathMatch === 'full')
    ) {
      return null;
    }

    const consumed: UrlSegment[] = [];
    const posParams: { [name: string]: UrlSegment } = {};
    for (let index = 0; index < matchSegments.length; ++index) {
      const segment = segments[index].toString().toLowerCase();
      const matchSegment = matchSegments[index];

      if (matchSegment.startsWith(':')) {
        posParams[matchSegment.slice(1)] = segments[index];
        consumed.push(segments[index]);
      } else if (segment.toLowerCase() === matchSegment.toLowerCase()) {
        consumed.push(segments[index]);
      } else {
        return null;
      }
    }

    return { consumed, posParams };
  };
}

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {
    enableTracing: false, preloadingStrategy: CustomPreloadingStrategy
})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
